.toast {
  display: inline-flex;
  flex-direction: row;
  gap: var(--spacing-sm);
  align-items: center;
  border-radius: var(--radius-lg);
  font: var(--body-md-font);
  padding: var(--spacing-md);
  white-space: nowrap;
  border: var(--border-width-default) solid var(--border-subtle);
  box-shadow: var(--shadow-raised);
}

.icon {
  width: 24px;
  height: 24px;
}

.text {
  /* reset the margin from the default p tag */
  margin: 0;
  flex: 1;
}

.neutral {
  background: var(--surface-inverse);
  color: var(--content-inverse);
}

.success {
  background: var(--surface-status-success-subtle);
  color: var(--content-on-status-success-subtle);
}

.success svg {
  color: var(--content-status-success);
}

.error {
  background: var(--surface-status-error-subtle);
  color: var(--content-on-status-error-subtle);
}

.error svg {
  color: var(--content-status-error);
}

.warning {
  background: var(--surface-status-warning-subtle);
  color: var(--content-on-status-warning-subtle);
}

.warning svg {
  color: var(--content-status-warning);
}

/* TODO: the animations below need to be passed to react-toastify's cssTransition fn */

@keyframes ddsToastFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes ddsToastFadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.fadeIn {
  animation-duration: 300ms;
  animation-name: ddsToastFadeIn;
}

.fadeOut {
  animation-duration: 300ms;
  animation-name: ddsToastFadeOut;
}

.actionButton {
  margin-left: auto;
  font-weight: bold;
}
